.container {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1, 8px);
  padding: var(--tuna-spacing-2, 16px) var(--tuna-spacing-2, 16px) var(--tuna-spacing-1, 8px);
  background: var(--agent-accent-header-bg, transparent);
  border-bottom: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
}

.avatar {
  background-color: var(--agent-accent);
  color: var(--tuna-content-onColor);
  width: 28px;
  height: 28px;
}

.text {
  min-width: 0;
}

.name {
  color: var(--tuna-content-primary);
}

.roleLine {
  color: var(--tuna-content-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
